/**
 * Mobile fullscreen overlays (custom sheets) and Bootstrap modals share this band: above the sticky
 * mobile header (1060), below minimized file viewer bubbles (1150), below
 * the mobile nav drawer (1200/1210). See `custom.scss` for `--bs-modal-zindex` alignment.
 */
export const MOBILE_OVERLAY_BACKDROP_Z_INDEX = 1080;
export const MOBILE_OVERLAY_PANEL_Z_INDEX = 1090;

/** Second stacked sheet (e.g. source preview) above the primary mobile overlay, still below bubbles. */
export const MOBILE_OVERLAY_STACKED_BACKDROP_Z_INDEX = 1120;
export const MOBILE_OVERLAY_STACKED_PANEL_Z_INDEX = 1130;

/**
 * Minimized file viewer dock (`MinimizedFileViewersContext`). Above sheets/modals, below drawer.
 */
export const MINIMIZED_FILE_VIEWERS_Z_INDEX = 1150;

/** Bottom action toast (undo / timed confirm). Above file dock, below the mobile drawer. */
export const ACTION_TOAST_Z_INDEX = 1160;

/**
 * Doctor patient-context chat floating panel on review detail (desktop).
 * Above the sticky mobile header; below mobile fullscreen sheets.
 */
export const DOCTOR_CONTEXT_CHAT_FLOATING_Z_INDEX = 1075;
